// extracted by mini-css-extract-plugin
export default {"media":"_f68bb8ad"};